var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.closed
    ? _c("div", {
        staticClass: "location__hours mt-1",
        class: { "text-green": _vm.hours.isOpen },
        domProps: { innerHTML: _vm._s(_vm.hoursRemaining) }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27a23beb", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// /Users/kristinberlehner/sites/mardens/wp-content/themes/mardens/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27a23beb","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!/Users/kristinberlehner/sites/mardens/wp-content/themes/mardens/node_modules/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/Hours.vue
// module id = 411
// module chunks = 0